export const getTeamMembersUrl = () => 'agency/team_members';

export const getTeamMemberUrl = (id: string) => `agency/team_members/${id}`;
